import { css, injectGlobal } from 'styled-components';
import { grey300, cream } from './colors';
import { media } from './utils';

const maxWidth = 1280;

injectGlobal`
    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background: ${cream};
        color: black;
        font-size: 16px;
        position: relative;
    }

    a {
        text-decoration: none;
    }

    a, p, div {
        color: black;
    }

    p {
        margin: 0;
    }

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;

    ::-webkit-scrollbar {
        width: 0px;  
        background: transparent;  
    }
   

`;

export const container = css`
    max-width: ${maxWidth}px;
`

export const hoverState = css`
    transition: 0.15s opacity ease;

    &:hover {
        opacity: 0.7;
    }
`

export const padding = css`
    padding-left: 14px; 
    padding-right: 14px;

    ${media.phone`
        padding-left: 10px; 
        padding-right: 10px;
    `}
`

export const line = css`
    width: 100%;
    height: 1px;
    background-color: grey;
    
    margin-bottom: ${props => props.marginBottom ? 55 : 0}px;

    ${media.phone`
        margin-bottom: ${props => props.marginBottom ? 40 : 0}px;
    `}
`

export const bgImage = css`
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
`

export const bgIcon = css`
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
`

export const indicator = css`

`


// WEBPACK FOOTER //
// ./client/styles/global.js